module.exports = __webpack_public_path__ + "img/hef_alarielle_campaign_0.1fded220.png";